import React, { useState, useEffect, useRef } from "react";
import { Variables } from "../../Variations/Variations";
import { useParams } from "react-router";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Loader from "../../Layout/Loader";
import { MdManageSearch, MdOutlineAssignmentReturned } from "react-icons/md";
import { AiOutlineRight } from "react-icons/ai";
import { BiTrash } from "react-icons/bi";
import Cookies from "js-cookie";

const ManageCoupons = () => {
  const navigate = useNavigate();
  const token = Cookies.get("UserToken");
  let { CouponID } = useParams();

  //#region Coupon
  const [name, setName] = useState("");
  const [priority, setPriority] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [isPublished, setIsPublished] = useState(false);
  const [freeShipping, setFreeShipping] = useState(false);
  const [couponTypeId, setCouponTypeId] = useState(0);
  const [isCoupon, setIsCoupon] = useState(false);
  const [isAppliedToRangeOfPrices, setIsAppliedToRangeOfPrices] =
    useState(false);
  const [startTotal, setStartTotal] = useState(0);
  const [endTotal, setEndTotal] = useState(0);
  const [couponCode, setCouponCode] = useState("");
  const [limit, setLimit] = useState(0);
  const [usage, setUsage] = useState(0);
  const [amount, setAmount] = useState(0);
  const [percentage, setPercentage] = useState(0);
  const [isAppliedToAttributes, setIsAppliedToAttributes] = useState(false);
  const [isAppliedToCountries, setIsAppliedToCountries] = useState(false);
  const [isAppliedToGroups, setIsAppliedToGroups] = useState(false);
  const [isAppliedToCategories, setIsAppliedToCategories] = useState(false);
  const [isAppliedToProducts, setIsAppliedToProducts] = useState(false);
  let loader = useRef(true);
  const [isAppliedWithOtherCoupon, setIsAppliedWithOtherCoupon] =
    useState(false);
  const [couponTypes, setCouponTypes] = useState([]);
  const [action, setAction] = useState(0);
  const fetchCouponTypes = async () => {
    let response, result;
    response = await fetch(Variables.API_URL + "CouponType/GetCouponTypes");
    result = await response.json();
    setCouponTypes(result);
  };
  const fetchCoupon = async () => {
    let response, result;
    response = await fetch(Variables.API_URL + "Coupon/GetCoupon/" + CouponID);
    result = await response.json();
    setName(result.CouponName);
    setPriority(result.CouponPriority);
    setStartDate(result.StartDate);
    setExpiryDate(result.ExpiryDate);
    setCouponTypeId(parseInt(result.CouponTypeId));
    setIsPublished(result.IsPublished);
    setFreeShipping(result.IsFreeShipping);
    if (result.StartTotal != 0) {
      setStartTotal(result.StartTotal);
      setEndTotal(result.EndTotal);
      setIsAppliedToRangeOfPrices(result.IsAppliedToRangeOfPrices);
    }
    setIsAppliedWithOtherCoupon(result.IsAppliedWithOtherCoupon);
    setAmount(result.Amount);
    setPercentage(result.Percentage);
    setIsAppliedToAttributes(result.IsAppliedToAttributes);
    setIsAppliedToCategories(result.IsAppliedToCategories);
    setIsAppliedToCountries(result.IsAppliedToCountries);
    setIsAppliedToGroups(result.IsAppliedToGroups);
    setIsAppliedToProducts(result.IsAppliedToProducts);

    if (result.Amount !== 0) {
      setAction(1);
    } else {
      if (result.Percentage !== 0) {
        setAction(2);
      } else {
        setAction(0);
      }
    }

    setIsCoupon(result.IsCoupon);
    setCouponCode(result.CouponCode);
    setLimit(result.UserLimit);
    setUsage(result.UsageTries);
  };
  function handleExpiryDate(e) {
    if (e.target.value < startDate) {
      document.getElementById("ExpiryDate").focus();
      setExpiryDate("");
      toast.error("End date should be higher than the Start date");
    } else {
      setExpiryDate(e.target.value);
    }
  }

  function handleLimit(e) {
    if (e.target.value < 0) {
      toast.error("Cannot Insert A Negative Value");
      setLimit(0);
    } else {
      setLimit(e.target.value);
    }
  }

  function handleAction(value) {
    setAction(value);
    if (value == 0) {
      setAmount(0);
      setPercentage(0);
    }
    if (value == 1) {
      setPercentage(0);
    }
    if ((value = 2)) {
      setAmount(0);
    }
  }
  function handleIsCoupon(e) {
    setIsCoupon(e.target.checked);
    if (e.target.checked === false) {
      setLimit(0);
      setUsage(0);
      setCouponCode("");
    }
  }
  function handleAmount(e) {
    if (e.target.value < 0) {
      toast.error("Cannot Insert A Negative Value");
      setAmount(0);
    } else {
      setAmount(e.target.value);
      var result = [];
      if (e.target.value === "") {
        result = filteredUnAssignedProducts;
      } else {
        unassignedProducts.forEach((element) => {
          var variations = [];
          element.Product.Variation.forEach((v) => {
            if (v.RegularPrice > e.target.value) {
              variations.push(v);
            }
          });
          if (variations.length != 0) {
            var obj = {
              Product: {
                ProductId: element.Product.ProductId,
                ProductName: element.Product.ProductName,
                Sku: element.Product.Sku,
                Variation: variations,
              },
            };
            result.push(obj);
          }
        });
      }
      setfilteredUnAssignedProducts(result);
    }
  }

  function IsValid() {
    if (name === "") {
      toast.error("Please Fill All Required Fields");
      return false;
    }
    if (isAppliedToCountries === true && assignedCountries.length == 0) {
      toast.error("Please Choose A Country");
      return false;
    }
    if (isAppliedToAttributes === true && assignedAttributeValues.length == 0) {
      toast.error("Please Choose An Attribute Value");
      return false;
    }
    if (isAppliedToCategories === true && assignedCategories.length == 0) {
      toast.error("Please Choose A Category");
      return false;
    }
    if (isAppliedToGroups === true && assignedGroups.length == 0) {
      toast.error("Please Choose A Group");
      return false;
    }
    if (isAppliedToProducts === true && assignedProducts.length == 0) {
      toast.error("Please Choose A product");
      return false;
    }

    if (couponTypeId == 0) {
      toast.error("Please Choose A Coupon Type");
      return false;
    }
    if (amount == 0 && percentage == 0) {
      toast.error("Please Fill All required Fields");
      return false;
    }

    if (isAppliedToRangeOfPrices === true) {
      if (startTotal == 0 && endTotal == 0) {
        toast.error("Please Fill All required Fields");
        return false;
      } else {
        if (startTotal > endTotal) {
          toast.error("Please choose an end total higher than the start ");
          return false;
        }
      }
    }

    if (startDate === "" || expiryDate === "") {
      toast.error("Please Choose A Start And End Date");
      return false;
    }

    if (couponTypeId == 1) {
      if (isCoupon === true) {
        if (couponCode === "") {
          toast.error("Please Fill All required Fields");
          return false;
        }
        if (limit == 0) {
          toast.error("Please Fill All required Fields");
          return false;
        }
        if (usage == 0) {
          toast.error("Please Fill All required Fields");
          return false;
        }
      }
    }

    if (priority === "") {
      toast.error("Please Fill All Required Fields");
      return false;
    }
    if (percentage > 100) {
      toast.error("You cannot choose a percentage higher than 100");
      return false;
    }

    return true;
  }

  function HandleSubmit(e) {
    if (IsValid()) {
      var amountToPost = amount;
      var percentageToPost = percentage;
      var limitToPost = limit;
      var usageToPost = usage;
      var startTotalToPost = startTotal;
      var endTotalToPost = endTotal;
      var priorityToPost = priority;
      if (priority === "") {
        priorityToPost = 0;
      }
      if (limit === "") {
        limitToPost = 0;
      }
      if (usage === "") {
        usageToPost = 0;
      }
      if (startTotal === "") {
        startTotalToPost = 0;
      }
      if (endTotal === "") {
        endTotalToPost = 0;
      }
      if (action == 2) {
        amountToPost = 0;
      }
      if (action == 1) {
        percentageToPost = 0;
      }

      e.preventDefault();
      if (CouponID == 0) {
        const addCoupon = async () => {
          let response = await fetch(Variables.API_URL + "Coupon/AddCoupon", {
            method: "Post",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
              "Access-Control-Allow-Origin": Variables.API_URL,
            },
            body: JSON.stringify({
              CouponName: name,
              CouponTypeId: couponTypeId,
              Amount: amountToPost,
              Percentage: percentageToPost,
              IsFreeShipping: freeShipping,
              isAppliedToRangeOfPrices: isAppliedToRangeOfPrices,
              startTotal: startTotalToPost,
              endTotal: endTotalToPost,
              startDate: startDate,
              expiryDate: expiryDate,
              IsPublished: isPublished,
              IsCoupon: isCoupon,
              CouponCode: couponCode,
              CouponPriority: priorityToPost,
              UsageTries: usageToPost,
              UserLimit: limitToPost,
              isAppliedToAttributes: isAppliedToAttributes,
              isAppliedToCategories: isAppliedToCategories,
              isAppliedToCountries: isAppliedToCountries,
              isAppliedToGroups: isAppliedToGroups,
              isAppliedToProducts: isAppliedToProducts,
              isAppliedWithOtherCoupon: isAppliedWithOtherCoupon,
            }),
          });
          let result = await response.json();
          if (response.status === 200) {
            navigate("/Coupons/" + result);
          } else {
            toast.error(result);
          }
        };
        setTimeout(() => {
          (async () => await addCoupon())();
        }, 100);
      } else {
        loader.current = true;
        const updateCoupon = async () => {
          let response = await fetch(
            Variables.API_URL + "Coupon/UpdateCoupon/" + CouponID,
            {
              method: "Put",
              headers: {
                Accept: "application/json",
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": Variables.API_URL,
              },
              body: JSON.stringify({
                CouponName: name,
                CouponTypeId: couponTypeId,
                Amount: amountToPost,
                Percentage: percentageToPost,
                IsFreeShipping: freeShipping,
                isAppliedToRangeOfPrices: isAppliedToRangeOfPrices,
                startTotal: startTotalToPost,
                endTotal: endTotalToPost,
                startDate: startDate,
                expiryDate: expiryDate,
                IsPublished: isPublished,
                IsCoupon: isCoupon,
                CouponCode: couponCode,
                CouponPriority: priorityToPost,
                UsageTries: usageToPost,
                UserLimit: limitToPost,
                isAppliedToAttributes: isAppliedToAttributes,
                isAppliedToCategories: isAppliedToCategories,
                isAppliedToCountries: isAppliedToCountries,
                isAppliedToGroups: isAppliedToGroups,
                isAppliedToProducts: isAppliedToProducts,
                isAppliedWithOtherCoupon: isAppliedWithOtherCoupon,
              }),
            }
          );
          let result = await response.json();

          if (response.status === 200) {
            toast.success(result);
            navigate("/Coupons");
            loader.current = false;
          } else {
            toast.error(result);
            loader.current = false;
          }
        };
        setTimeout(() => {
          (async () => await updateCoupon())();
        }, 100);
      }
    }
  }
  function handlePriority(e) {
    if (e.target.value < 0) {
      toast.error("Cannot Insert A Negative Value");
      setPriority(0);
    } else {
      setPriority(e.target.value);
    }
  }
  function handlePriceRange(e) {
    setIsAppliedToRangeOfPrices(e.target.checked);
    if (e.target.checked === false) {
      setStartTotal(0);
      setEndTotal(0);
    }
  }
  //#endregion

  //#region Countries
  const [unassignedCountries, setUnassignedCountries] = useState([]);
  const [assignedCountries, setAssignedCountries] = useState([]);
  const [isOpenUnassignedCountries, setIsOpenUnassignedCountries] =
    useState(false);
  const [filteredAssignedCountries, setFilteredAssignedCountries] = useState(
    []
  );
  const [filteredUnAssignedCountries, setFilteredUnAssignedCountries] =
    useState([]);
  const fecthUnAssignedCountries = async () => {
    let response, result;
    response = await fetch(
      Variables.API_URL +
      "AssignCountriesToCoupon/GetUnAssignedCountriesForCoupon/" +
      CouponID,{headers:{
        "Authorization": `Bearer ${token}`,
      }}
    );
    result = await response.json();

    var array = [];
    for (var i = 0; i < result.length; i++) {
      array.push(result[i]);
    }
    setUnassignedCountries(array);
    setFilteredUnAssignedCountries(array);
  };
  const fetchAssignedCountries = async () => {
    let response, result;
    response = await fetch(
      Variables.API_URL +
      "AssignCountriesToCoupon/GetAssignedCountries/" +
      CouponID,{
        headers:{
          "Authorization": `Bearer ${token}`,
        }
      }
    );
    result = await response.json();
    if (response.status == 200) {
      var array = [];
      for (var i = 0; i < result.length; i++) {
        array.push(result[i]);
      }
      setAssignedCountries(array);
      setFilteredAssignedCountries(array);
      loader.current = false;
    }
  };

  const unassignedCountriesColumns = [
    {
      name: "ID",
      selector: (row) => row.CountryId,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.CountryName,
      sortable: true,
    },
    {
      name: "Code",
      selector: (row) => row.CountryCode,
      sortable: true,
    },
    {
      name: "Assign",
      selector: (row) => (
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => AssignCountry(row.CountryId)}
        >
          <MdOutlineAssignmentReturned />
        </button>
      ),
    },
  ];

  const assignedCountriesColumns = [
    {
      name: "ID",
      selector: (row) => row.CountryId,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.CountryName,
      sortable: true,
    },
    {
      name: "Code",
      selector: (row) => row.CountryCode,
      sortable: true,
    },
    {
      name: "UnAssign",
      selector: (row) => (
        <button
          className="btn btn-outline-danger btn-sm"
          onClick={() => UnAssignCountry(row.CountryId)}
        >
          <BiTrash />
        </button>
      ),
    },
  ];

  async function AssignCountry(CountryId) {
    let response = await fetch(
      Variables.API_URL + "AssignCountriesToCoupon/AssignCountryToCoupon",
      {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CountryId: CountryId,
          CouponId: CouponID,
        }),
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result);
      fecthUnAssignedCountries();
      fetchAssignedCountries();
      setIsOpenUnassignedCountries(false);
    } else {
      toast.error(result);
    }
  }

  async function AssignAllCountries() {
    for (var i = 0; i < unassignedCountries.length; i++) {
      let response = await fetch(
        Variables.API_URL + "AssignCountriesToCoupon/AssignCountryToCoupon",
        {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            CountryId: unassignedCountries[i].CountryId,
            CouponId: CouponID,
          }),
        }
      );
    }
    fecthUnAssignedCountries();
    fetchAssignedCountries();
  }
  async function UnAssignCountry(CountryId) {
    let response = await fetch(
      Variables.API_URL + "AssignCountriesToCoupon/UnAssignCountryToCoupon",
      {
        method: "Delete",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CountryId: CountryId,
          CouponId: CouponID,
        }),
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result);
      fetchAssignedCountries();
      fecthUnAssignedCountries();
    } else {
      toast.error(result);
    }
  }

  function handleSearchAssignedCountries(e) {
    let value = e.target.value.toLowerCase();
    let result = [];
    if (value === "") {
      setFilteredAssignedCountries(filteredAssignedCountries);
    } else {
      result = assignedCountries.filter((data) => {
        return data.CountryName.toLowerCase().search(value) != -1;
      });
      setFilteredAssignedCountries(result);
    }
  }
  function handleSearchUnAssignedCountries(e) {
    let value = e.target.value.toLowerCase();
    let result = [];
    if (value === "") {
      setFilteredUnAssignedCountries(filteredUnAssignedCountries);
    } else {
      result = unassignedCountries.filter((data) => {
        return data.CountryName.toLowerCase().search(value) != -1;
      });
      setFilteredUnAssignedCountries(result);
    }
  }

  //#endregion

  //#region Groups
  const [unassignedGroups, setUnassignedGroups] = useState([]);
  const [assignedGroups, setAssignedGroups] = useState([]);
  const [isOpenUnassignedGroups, setIsOpenUnassignedGroups] = useState(false);
  const [assignedGroupsLoading, setAssignedGroupsLoading] = useState(true);
  const [filteredUnAssignedGroups, setFilteredUnAssignedGroups] = useState([]);
  const [filteredAssignedGroups, setFilteredAssignedGroups] = useState([]);
  const fecthUnAssignedGroups = async () => {
    let response, result;
    response = await fetch(
      Variables.API_URL +
      "AssignCouponToGroup/GetUnAssignedGroupsForCoupon/" +
      CouponID,{
        headers:{
          "Authorization": `Bearer ${token}`,
        }
      }
    );
    result = await response.json();

    var array = [];
    for (var i = 0; i < result.length; i++) {
      array.push(result[i]);
    }
    setUnassignedGroups(array);
    setFilteredUnAssignedGroups(array);
  };

  const fetchAssignedGroups = async () => {
    let response, result;
    response = await fetch(
      Variables.API_URL + "AssignCouponToGroup/GetAssignedGroups/" + CouponID,{
        headers:{
          "Authorization": `Bearer ${token}`,
        }
      }
    );
    result = await response.json();
    if (response.status == 200) {
      setAssignedGroups(result);
      setFilteredAssignedGroups(result);
      loader.current = false;
    }
  };

  function handleSearchAssignedGroups(e) {
    let value = e.target.value.toLowerCase();
    let result = [];
    result = assignedGroups.filter((data) => {
      return data.GroupName.toLowerCase().search(value) != -1;
    });
    setFilteredAssignedCountries(result);
  }
  function handleSearchUnAssignedGroups(e) {
    let value = e.target.value.toLowerCase();
    let result = [];
    result = unassignedGroups.filter((data) => {
      return data.GroupName.toLowerCase().search(value) != -1;
    });
    setFilteredUnAssignedCountries(result);
  }
  const unassignedGroupsColumns = [
    {
      name: "ID",
      selector: (row) => row.CouponGroupId,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.Name,
      sortable: true,
    },

    {
      name: "Assign",
      selector: (row) => (
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => AssignGroup(row.CouponGroupId)}
        >
          <MdOutlineAssignmentReturned />
        </button>
      ),
    },
  ];

  const assignedGroupsColumns = [
    {
      name: "ID",
      selector: (row) => row.CouponGroupId,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.Name,
      sortable: true,
    },

    {
      name: "UnAssign",
      selector: (row) => (
        <button
          className="btn btn-outline-danger btn-sm"
          onClick={() => UnAssignGroup(row.CouponGroupId)}
        >
          <BiTrash />
        </button>
      ),
    },
  ];
  async function AssignGroup(GroupId) {
    let response = await fetch(
      Variables.API_URL + "AssignCouponToGroup/AssignGroupToCoupon",
      {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CouponGroupId: GroupId,
          CouponId: CouponID,
        }),
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result);
      fecthUnAssignedGroups();
      fetchAssignedGroups();
      setIsOpenUnassignedGroups(false);
    } else {
      toast.error(result);
    }
  }
  async function UnAssignGroup(GroupId) {
    let response = await fetch(
      Variables.API_URL + "AssignCouponToGroup/UnAssignGroupToCoupon",
      {
        method: "Delete",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CouponGroupId: GroupId,
          CouponId: CouponID,
        }),
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result);
      fetchAssignedGroups();
      fecthUnAssignedGroups();
      setIsOpenUnassignedGroups(false);
    } else {
      toast.error(result);
    }
  }
  async function AssignAllGroups() {
    for (var i = 0; i < unassignedGroups.length; i++) {
      let response = await fetch(
        Variables.API_URL + "AssignCouponToGroup/AssignGroupToCoupon",
        {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            GroupId: unassignedGroups[i].GroupId,
            CouponId: CouponID,
          }),
        }
      );
    }
    fecthUnAssignedGroups();
  }

  //#endregion

  //#region Categories
  const [isOpenUnAssignedCategories, setIsOpenUnAssignedCategories] =
    useState(false);
  const [unassignedCategories, setUnAssignedCategories] = useState([]);
  const [assignedCategories, setAssignedCategories] = useState([]);
  const [filteredUnAssignedCategories, setFilteredUnAssignedCategories] =
    useState([]);
  const [filteredAssignedCategories, setFilteredAssignedCategories] = useState(
    []
  );

  async function AssignAllCategories() {
    for (var i = 0; i < unassignedCategories.length; i++) {
      let response = await fetch(
        Variables.API_URL + "AssignCouponToCategory/AssignCategoryToCoupon",
        {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            CategoryId: unassignedCategories[i].CategoryId,
            CouponId: CouponID,
          }),
        }
      );
    }
    fecthUnAssignedCategories();
    fetchAssignedCategories();
    fecthAssignedProducts();
    setIsOpenUnAssignedCategories(false);
  }
  const unassignedCategoriesColumns = [
    {
      name: "ID",
      selector: (row) => row.CategoryId,
      sortable: true,
    },
    {
      name: " Category Name",
      selector: (row) => row.CategoryName,
      sortable: true,
    },

    {
      name: "Assign",
      selector: (row) => (
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => AssignCategory(row.CategoryId)}
        >
          <MdOutlineAssignmentReturned />
        </button>
      ),
    },
  ];
  const assignedCategoriesColumns = [
    {
      name: "ID",
      selector: (row) => row.CategoryId,
      sortable: true,
    },
    {
      name: " Category Name",
      selector: (row) => row.CategoryName,
      sortable: true,
    },

    {
      name: "UnAssign",
      selector: (row) => (
        <button
          className="btn btn-outline-danger btn-sm"
          onClick={() => UnAssignCategory(row.CategoryId)}
        >
          <BiTrash />
        </button>
      ),
    },
  ];
  const fecthUnAssignedCategories = async () => {
    let response, result;
    response = await fetch(
      Variables.API_URL +
      "AssignCouponToCategory/GetUnAssignedCategoriesForCoupon/" +
      CouponID,{
        headers:{
          "Authorization": `Bearer ${token}`,
        }
      }
    );
    result = await response.json();

    var array = [];
    for (var i = 0; i < result.length; i++) {
      array.push(result[i]);
    }
    setUnAssignedCategories(array);
    setFilteredUnAssignedCategories(array);
  };

  const fetchAssignedCategories = async () => {
    let response, result;
    response = await fetch(
      Variables.API_URL +
      "AssignCouponToCategory/GetAssignedCategories/" +
      CouponID,{
        headers:{
          "Authorization": `Bearer ${token}`,
        }
      }
    );
    result = await response.json();
    if (response.status == 200) {
      setAssignedCategories(result);
      setFilteredAssignedCategories(result);
      fetchUnAssignedProducts(
        isAppliedToAttributes,
        isAppliedToCategories,
        assignedAttributeValues,
        result
      );
      loader.current = false;
    }
  };

  async function AssignCategory(CategoryId) {
    let response = await fetch(
      Variables.API_URL + "AssignCouponToCategory/AssignCategoryToCoupon",
      {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CategoryId: CategoryId,
          CouponId: CouponID,
        }),
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result);
      fecthUnAssignedCategories();
      fetchAssignedCategories();
      fecthAssignedProducts();
      setIsOpenUnAssignedCategories(false);
    } else {
      toast.error(result);
    }
  }
  async function UnAssignCategory(CategoryId) {
    let response = await fetch(
      Variables.API_URL + "AssignCouponToCategory/UnAssignCategoryToCoupon",
      {
        method: "Delete",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CategoryId: CategoryId,
          CouponId: CouponID,
        }),
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result);
      fetchAssignedCategories();
      fecthUnAssignedCategories();
      fecthAssignedProducts();
    } else {
      toast.error(result);
    }
  }

  function handleSearchAssignedCategories(e) {
    let value = e.target.value.toLowerCase();
    let result = [];
    result = assignedCategories.filter((data) => {
      return data.CategoryName.toLowerCase().search(value) != -1;
    });
    setFilteredAssignedCategories(result);
  }
  function handleSearchUnAssignedCategories(e) {
    let value = e.target.value.toLowerCase();
    let result = [];
    result = unassignedCategories.filter((data) => {
      return data.CategoryName.toLowerCase().search(value) != -1;
    });
    setFilteredUnAssignedCategories(result);
  }

  //#endregion

  //#region Attribute Values

  const [isOpenUnAssignedAttributeValues, setisOpenUnAssignedAttributeValues] =
    useState(false);
  const [assignedAttributeValues, setassignedAttributeValues] = useState([]);
  const [filteredAssignedAttributeValues, setfilteredAssignedAttributeValues] =
    useState([]);
  const [unassignedAttributeValues, setunassignedAttributeValues] = useState(
    []
  );
  const [
    filteredUnAssignedAttributeValues,
    setfilteredUnAssignedAttributeValues,
  ] = useState([]);
  const unassignedAttributeValuesColumns = [
    {
      name: "ID",
      selector: (row) => row.AttributeValueId,
      sortable: true,
    },
    {
      name: " Attribute Value Name ",
      selector: (row) => row.AttributeValueName,
      sortable: true,
    },

    {
      name: "Assign",
      selector: (row) => (
        <button className="btn btn-outline-secondary btn-sm" onClick={() => AssignAttributeValue(row)}>
          <MdOutlineAssignmentReturned />
        </button>
      ),
    },
  ];
  const assignedAttributeValuesColumns = [
    {
      name: "ID",
      selector: (row) => row.AttributeValueId,
      sortable: true,
    },
    {
      name: " Attribute Value Name",
      selector: (row) => row.AttributeValueName,
      sortable: true,
    },

    {
      name: "UnAssign",
      selector: (row) => (
        <button
          className="btn btn-outline-danger btn-sm"
          onClick={() => UnAssignAttributeValue(row.AttributeValueId)}
        >
          <BiTrash />
        </button>
      ),
    },
  ];
  const fecthUnAssignedAttributeValues = async () => {
    let response, result;
    response = await fetch(
      Variables.API_URL +
      "AssignCouponToAttributeValue/GetUnAssignedAttributeValuesForCoupon/" +
      CouponID,{
        headers:{
          "Authorization": `Bearer ${token}`,
        }
      }
    );
    result = await response.json();
    if (response.status === 200) {
      setunassignedAttributeValues(result);
      setfilteredUnAssignedAttributeValues(result);
    }
  };
  const fetchAssignedAttributeValues = async () => {
    let response, result;
    response = await fetch(
      Variables.API_URL +
      "AssignCouponToAttributeValue/GetAssignedAttributeValues/" +
      CouponID,{
        headers:{
          "Authorization": `Bearer ${token}`,
        }
      }
    );
    result = await response.json();
    if (response.status == 200) {
      setassignedAttributeValues(result);
      setfilteredAssignedAttributeValues(result);
      fetchUnAssignedProducts(
        isAppliedToAttributes,
        isAppliedToCategories,
        result,
        assignedCategories
      );
      loader.current = false;
    }
  };
  async function AssignAttributeValue(row) {
    let response = await fetch(
      Variables.API_URL +
      "AssignCouponToAttributeValue/AssignAttributeValueToCoupon",
      {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          AttributeValueId: row.AttributeValueId,
          CouponId: CouponID,
        }),
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      var array = [...assignedAttributeValues];
      array.push(row);
      setassignedAttributeValues(array);
      toast.success(result);
      fecthUnAssignedAttributeValues();
      fetchAssignedAttributeValues();
      fecthAssignedProducts();

      setisOpenUnAssignedAttributeValues(false);
    } else {
      toast.error(result);
    }
  }

  async function UnAssignAttributeValue(AttributeValueId) {
    let response = await fetch(
      Variables.API_URL +
      "AssignCouponToAttributeValue/UnAssignAttributeValueToCoupon",
      {
        method: "Delete",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          AttributeValueId: AttributeValueId,
          CouponId: CouponID,
        }),
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result);
      fetchAssignedAttributeValues();
      fecthUnAssignedAttributeValues();
      fecthAssignedProducts();
    } else {
      toast.error(result);
    }
  }
  function handleSearchAssignedAttributeValues(e) {
    let value = e.target.value.toLowerCase();
    let result = [];
    result = assignedAttributeValues.filter((data) => {
      return data.AttributeValueName.toLowerCase().search(value) != -1;
    });
    setfilteredAssignedAttributeValues(result);
  }
  function handleSearchUnAssignedAttributeValues(e) {
    let value = e.target.value.toLowerCase();
    let result = [];
    result = unassignedAttributeValues.filter((data) => {
      return data.AttributeValueName.toLowerCase().search(value) != -1;
    });
    setfilteredUnAssignedAttributeValues(result);
  }
  async function AssignAllAttributeValues() {
    for (var i = 0; i < unassignedAttributeValues.length; i++) {
      let response = await fetch(
        Variables.API_URL +
        "AssignCouponToAttributeValue/AssignAttributeValueToCoupon",
        {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            AttributeValueId: unassignedAttributeValues[i].AttributeValueId,
            CouponId: CouponID,
          }),
        }
      );
    }
    fecthUnAssignedAttributeValues();
    fecthAssignedProducts();
    fetchAssignedAttributeValues();
    setisOpenUnAssignedAttributeValues(false);
  }

  function handleAppliedToAttributes(e) {
    setIsAppliedToAttributes(e.target.checked);
    fetchUnAssignedProducts(
      e.target.checked,
      isAppliedToCategories,
      assignedAttributeValues,
      assignedCategories
    );
    setIsAppliedToProducts(false);
  }
  function handleIsAppliedToCategories(e) {
    setIsAppliedToCategories(e.target.checked);
    fetchUnAssignedProducts(
      isAppliedToAttributes,
      e.target.checked,
      assignedAttributeValues,
      assignedCategories
    );
    setIsAppliedToProducts(false);
  }

  function handleIsAppliedToProducts(e) {
    setIsAppliedToProducts(e.target.checked);

    fetchUnAssignedProducts(
      isAppliedToAttributes,
      isAppliedToCategories,
      assignedAttributeValues,
      assignedCategories
    );
  }

  //#endregion

  //#region Products
  const [isOpenUnAssignedProducts, setisOpenUnAssignedProducts] =
    useState(false);
  const [assignedProducts, setassignedProducts] = useState([]);
  const [filteredAssignedProducts, setfilteredAssignedProducts] = useState([]);
  const [unassignedProducts, setunassignedProducts] = useState([]);
  const [filteredUnAssignedProducts, setfilteredUnAssignedProducts] = useState(
    []
  );

  const unassignedExpandableRows = ({ data }) => (
    <DataTable
      className="ml-3"
      columns={unassignedvariationColumns}
      data={data.Product.Variation}
    />
  );
  const assignedExpandableRows = ({ data }) => (
    <DataTable
      className="ml-3"
      columns={assignedvariationColumns}
      data={data.Product.Variation}
    />
  );
  const unassignedProductsColumns = [
    {
      name: "ID",
      selector: (row) => row.Product.ProductId,
      sortable: true,
    },
    {
      name: " Product Name ",
      selector: (row) => row.Product.ProductName,
      sortable: true,
    },

    {
      name: "Assign All",
      selector: (row) => (
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => AssignProduct(row.Product.ProductId)}
        >
          <MdOutlineAssignmentReturned />
        </button>
      ),
    },
  ];
  const unassignedvariationColumns = [
    {
      name: "ID",
      selector: (row) => row.ProductVariationId,
      sortable: true,
    },
    {
      name: " Sku ",
      selector: (row) => row.Sku,
      sortable: true,
    },
    {
      name: " Stock ",
      selector: (row) => row.Stock,
      sortable: true,
    },
    {
      name: " Regular Price ",
      selector: (row) => row.RegularPrice,
      sortable: true,
    },
    {
      name: " Color ",
      selector: (row) => row.Color,
      sortable: true,
    },
    {
      name: " Size ",
      selector: (row) => row.Size,
      sortable: true,
    },

    {
      name: "Assign",
      selector: (row) => (
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => AssignProductVariation(row.ProductVariationId)}
        >
          <MdOutlineAssignmentReturned />
        </button>
      ),
    },
  ];

  const assignedProductsColumns = [
    {
      name: "ID",
      selector: (row) => row.Product.ProductId,
      sortable: true,
    },
    {
      name: " Product Name",
      selector: (row) => row.Product.ProductName,
      sortable: true,
    },

    {
      name: "UnAssign All",
      selector: (row) => (
        <button
          className="btn btn-outline-danger btn-sm"
          onClick={() => UnAssignProduct(row.Product.ProductId)}
        >
          <MdOutlineAssignmentReturned />
        </button>
      ),
    },
  ];

  const assignedvariationColumns = [
    {
      name: "ID",
      selector: (row) => row.ProductVariationId,
      sortable: true,
    },
    {
      name: " Sku ",
      selector: (row) => row.Sku,
      sortable: true,
    },
    {
      name: " Stock ",
      selector: (row) => row.Stock,
      sortable: true,
    },
    {
      name: " Regular Price ",
      selector: (row) => row.RegularPrice,
      sortable: true,
    },
    {
      name: " Color ",
      selector: (row) => row.Color,
      sortable: true,
    },
    {
      name: " Size ",
      selector: (row) => row.Size,
      sortable: true,
    },

    {
      name: "UnAssign",
      selector: (row) => (
        <button
          className="btn btn-outline-danger btn-sm"
          onClick={() => UnAssignProductVariation(row.ProductVariationId)}
        >
          <BiTrash />
        </button>
      ),
    },
  ];

  const fetchUnAssignedProducts = async (
    isAttributes,
    isCategories,
    attributes,
    categories
  ) => {
    var attributeToPost = [];
    var catToPost = [];
    if (isAttributes === true || isCategories === true) {
      if (isAttributes === true) {
        if (attributes.length != 0) {
          attributes.forEach((element) => {
            attributeToPost.push(element.AttributeValueId);
          });
        }
      }
      if (isCategories === true) {
        if (categories.length != 0) {
          categories.forEach((element) => {
            catToPost.push(element.CategoryId);
          });
        }
      }
      let response1 = await fetch(
        Variables.API_URL +
        "AssignCouponToProduct/GetUnAssignedProductsOfAttributesAndCategories/" +
        CouponID,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": Variables.API_URL,
          },

          body: JSON.stringify({
            attributes: attributeToPost,
            categories: catToPost,
            IsPriceRange: isAppliedToRangeOfPrices,
            StartTotal: startTotal,
            EndTotal: endTotal,
          }),
        }
      );
      let result1 = await response1.json();
      setunassignedProducts(result1);
      var products = [];
      if (amount === "") {
        products = result1;
      } else {
        result1.forEach((element) => {
          var variations = [];
          element.Product.Variation.forEach((v) => {
            if (v.RegularPrice > amount) {
              variations.push(v);
            }
          });
          if (variations.length != 0) {
            var obj = {
              Product: {
                ProductId: element.Product.ProductId,
                ProductName: element.Product.ProductName,
                Sku: element.Product.Sku,
                Variation: variations,
              },
            };
            products.push(obj);
          }
        });
      }
      setfilteredUnAssignedProducts(products);
    } else {
      let response = await fetch(
        Variables.API_URL +
        "AssignCouponToProduct/GetUnAssignedProductsForCoupon/" +
        CouponID,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": Variables.API_URL,
          },

          body: JSON.stringify({
            IsPriceRange: isAppliedToRangeOfPrices,
            StartTotal: startTotal,
            EndTotal: endTotal,
          }),
        }
      );
      let result = await response.json();
      setunassignedProducts(result);
      var products = [];
      if (amount === "") {
        products = result;
      } else {
        result.forEach((element) => {
          var variations = [];
          element.Product.Variation.forEach((v) => {
            if (v.RegularPrice > amount) {
              variations.push(v);
            }
          });
          if (variations.length != 0) {
            var obj = {
              Product: {
                ProductId: element.Product.ProductId,
                ProductName: element.Product.ProductName,
                Sku: element.Product.Sku,
                Variation: variations,
              },
            };
            products.push(obj);
          }
        });
      }
      setfilteredUnAssignedProducts(products);
    }
  };
  const fecthAssignedProducts = async () => {
    let response, result;
    response = await fetch(
      Variables.API_URL +
      "AssignCouponToProduct/GetAssignedProducts/" +
      CouponID,{
        headers:{
          "Authorization": `Bearer ${token}`,
        }
      }
    );
    result = await response.json();
    if (response.status == 200) {
      setassignedProducts(result);
      setfilteredAssignedProducts(result);
      loader = false;
    }
  };
  async function AssignProduct(ProductId) {
    let response = await fetch(
      Variables.API_URL + "AssignCouponToProduct/AssignProductToCoupon",
      {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ProductId: ProductId,
          CouponId: CouponID,
        }),
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result);
      var attributes = [];
      var categories = [];
      if (isAppliedToProducts === true && assignedAttributeValues.length != 0) {
        attributes = assignedAttributeValues;
      }
      if (isAppliedToCategories === true && assignedCategories.length != 0) {
        categories = assignedCategories;
      }
      fetchUnAssignedProducts(
        isAppliedToAttributes,
        isAppliedToCategories,
        attributes,
        categories
      );

      fecthAssignedProducts();
      setisOpenUnAssignedProducts(false);
    } else {
      toast.error(result);
    }
  }
  async function AssignProductVariation(ProductVariationId) {
    let response = await fetch(
      Variables.API_URL +
      "AssignCouponToProduct/AssignProductVariationToCoupon",
      {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ProductVariationId: ProductVariationId,
          CouponId: CouponID,
        }),
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result);
      var attributes = [];
      var categories = [];
      if (isAppliedToProducts === true && assignedAttributeValues.length != 0) {
        attributes = assignedAttributeValues;
      }
      if (isAppliedToCategories === true && assignedCategories.length != 0) {
        categories = assignedCategories;
      }
      fetchUnAssignedProducts(
        isAppliedToAttributes,
        isAppliedToCategories,
        attributes,
        categories
      );

      fecthAssignedProducts();
      setisOpenUnAssignedProducts(false);
    } else {
      toast.error(result);
    }
  }
  async function UnAssignProduct(ProductId) {
    let response = await fetch(
      Variables.API_URL + "AssignCouponToProduct/UnAssignProduct",
      {
        method: "Delete",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ProductId: ProductId,
          CouponId: CouponID,
        }),
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result);
      var attributes = [];
      var categories = [];
      if (isAppliedToProducts === true && assignedAttributeValues.length != 0) {
        attributes = assignedAttributeValues;
      }
      if (isAppliedToCategories === true && assignedCategories.length != 0) {
        categories = assignedCategories;
      }
      fetchUnAssignedProducts(
        isAppliedToAttributes,
        isAppliedToCategories,
        attributes,
        categories
      );
      fecthAssignedProducts();
      setisOpenUnAssignedProducts(false);
    } else {
      toast.error(result);
    }
  }
  async function UnAssignProductVariation(ProductVariationId) {
    let response = await fetch(
      Variables.API_URL +
      "AssignCouponToProduct/UnAssignProductVariationToCoupon",
      {
        method: "Delete",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ProductVariationId: ProductVariationId,
          CouponId: CouponID,
        }),
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result);
      var attributes = [];
      var categories = [];
      if (isAppliedToProducts === true && assignedAttributeValues.length != 0) {
        attributes = assignedAttributeValues;
      }
      if (isAppliedToCategories === true && assignedCategories.length != 0) {
        categories = assignedCategories;
      }
      fetchUnAssignedProducts(
        isAppliedToAttributes,
        isAppliedToCategories,
        attributes,
        categories
      );
      fecthAssignedProducts();
      setisOpenUnAssignedProducts(false);
    } else {
      toast.error(result);
    }
  }

  async function AssignAllProducts() {
    for (var i = 0; i < unassignedProducts.length; i++) {
      let response = await fetch(
        Variables.API_URL +
        "AssignCouponToProduct/AssignProductVariationToCoupon",
        {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ProductId: unassignedProducts[i].ProductId,
            CouponId: CouponID,
          }),
        }
      );
    }
    fetchUnAssignedProducts(
      isAppliedToAttributes,
      isAppliedToCategories,
      assignedAttributeValues,
      assignedCategories
    );
    setisOpenUnAssignedProducts(false);
  }
  function handleSearchAssignedProducts(e) {
    let value = e.target.value.toLowerCase();
    let result = [];
    result = assignedProducts.filter((data) => {
      return data.Product.ProductName.toLowerCase().search(value) != -1;
    });
    setfilteredAssignedProducts(result);
  }
  function handleSearchUnAssignedProducts(e) {
    let value = e.target.value.toLowerCase();
    let result = [];
    result = unassignedProducts.filter((data) => {
      return data.Product.ProductName.toLowerCase().search(value) != -1;
    });
    setfilteredUnAssignedProducts(result);
  }
  //#endregion

  useEffect(() => {
    if(Cookies.get("UserToken") === undefined){
      navigate("/Login");
    } else{
      fetchCouponTypes();
      if (CouponID != 0) {
        fetchCoupon();
      }
      fecthUnAssignedCountries();
      fetchAssignedCountries();
      fecthUnAssignedGroups();
      fetchAssignedGroups();
      fetchAssignedCategories();
      fecthUnAssignedCategories();
      fetchAssignedAttributeValues();
      fecthUnAssignedAttributeValues();
      fecthAssignedProducts();
    }
   
  }, [CouponID]);
  return (
    <div className="rightSide">
      <div className="container-fluid">
        {loader.current ? (
          <Loader />
        ) : (
          <div>
            <div className="row">
              <div className="col-12">
                <h2>{CouponID == "0" ? "Add" : "Update"} Coupon</h2>
                <ul className="portalPath">
                  <li>Home <AiOutlineRight /></li>
                  <li><Link to="/Coupons">Coupon <AiOutlineRight /></Link></li>
                  <li>Manage Coupon</li>
                </ul>
              </div>
            </div>
            <div className="card mb-5">
              <div className="card-header">
                <div className="row">
                  <div className="col-6">
                    <h3>
                      {name + " "} Coupon{" "}
                    </h3>
                  </div>
                  <div className="col-6 text-end">
                    <button
                      className="btn btn-primary "
                      onClick={HandleSubmit}
                    >
                      {" "}
                      Save
                    </button>{" "}
                    <button
                      className="btn btn-secondary ms-2"
                      onClick={() => navigate("/Coupons")}
                    >
                      Cancel
                    </button>{" "}
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="card-body">
                    <div className="form-group row">
                      <div className="col-6">
                        <label>
                          Name <span className="required">*</span>{" "}
                        </label>
                        <input
                          type="text"
                          id="CouponName"
                          className="form-control"
                          placeholder="Name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                        ></input>
                      </div>

                      <div className="col-6">
                        <label>Priority </label>
                        <input
                          type="number"
                          id="CouponPriority"
                          className="form-control"
                          placeholder="Price"
                          min="0"
                          value={priority}
                          onChange={(e) => handlePriority(e)}
                          required
                        ></input>
                      </div>
                    </div>

                    <div className="form-group row mt-4">
                      <div className="col-3">
                        <label>
                          Start Date <span className="required">*</span>{" "}
                        </label>
                        <input
                          type="datetime-local"
                          id="StartDate"
                          className="form-control"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          required={true}
                        ></input>
                      </div>

                      <div className="col-3">
                        <label>
                          End Date <span className="required">*</span>
                        </label>
                        <input
                          type="datetime-local"
                          id="ExpiryDate"
                          className="form-control"
                          value={expiryDate}
                          onChange={(e) => handleExpiryDate(e)}
                          required={true}
                        ></input>
                      </div>

                      <div className="form-check col-3 pl-38 mt-4">
                        <label
                          className="form-check-label"
                          htmlFor="IsPublished"
                        >
                          Published
                        </label>
                        <input
                          type="checkbox"
                          id="IsPublished"
                          className="form-check-input ml-4"
                          value={isPublished}
                          checked={isPublished}
                          onChange={(e) => setIsPublished(e.target.checked)}
                        />
                      </div>

                      {couponTypeId == 1 ? (
                        <div className="form-check col-3 pl-38 mt-4">
                          <label
                            className="form-check-label"
                            htmlFor="IsFreeShipping"
                          >
                            Free Shipping
                          </label>
                          <input
                            type="checkbox"
                            id="IsFreeShipping"
                            className="form-check-input"
                            value={freeShipping}
                            checked={freeShipping}
                            onChange={(e) => setFreeShipping(e.target.checked)}
                          />
                        </div>
                      ) : null}
                    </div>
                    <div className="form-group row mt-4">
                      <div className="col-6">
                        <label>Type</label>
                        <select
                          id="CouponTypeId"
                          className="form-control"
                          value={couponTypeId}
                          onChange={(e) => setCouponTypeId(e.target.value)}
                        >
                          <option key="0" value="0">
                            -- Select --
                          </option>
                          {couponTypes.map((type) => {
                            return (
                              <option
                                key={type.CouponTypeId}
                                value={type.CouponTypeId}
                              >
                                {type.TypeName}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      {couponTypeId != 0 ? (
                        <div className="form-check col-3 pl-38 mt-4">
                          <label
                            className="form-check-label"
                            htmlFor="DiscardSubsequentRules"
                          >
                            Discard Subsequent Rules
                          </label>
                          <input
                            type="checkbox"
                            id="DiscardSubsequentRules"
                            className="form-check-input"
                            value={isAppliedWithOtherCoupon}
                            checked={isAppliedWithOtherCoupon}
                            onChange={(e) =>
                              setIsAppliedWithOtherCoupon(e.target.checked)
                            }
                          />
                        </div>
                      ) : null}

                      {couponTypeId != 0 ? (
                        <div className="form-check col-3 pl-38 mt-4">
                          <label
                            className="form-check-label"
                            htmlFor="IsAppliedToRangeOfPrices"
                          >
                            {couponTypeId == 1 ? "Total Range" : ""}
                            {couponTypeId == 2 ? "Price Range" : ""}
                          </label>
                          <input
                            type="checkbox"
                            id="IsAppliedToRangeOfPrices"
                            className="form-check-input"
                            checked={isAppliedToRangeOfPrices}
                            value={isAppliedToRangeOfPrices}
                            onChange={(e) => handlePriceRange(e)}
                          />
                        </div>
                      ) : null}
                    </div>

                    {couponTypeId != 0 && isAppliedToRangeOfPrices === true ? (
                      <div className="form-group row mt-4">
                        <div className="col-6">
                          <label>
                            {couponTypeId == 1 ? "Start Total" : ""}{" "}
                            {couponTypeId == 2 ? "Start Price" : ""}
                          </label>
                          <input
                            type="number"
                            id="StartPrice"
                            className="form-control"
                            placeholder="Price"
                            min="0"
                            step="0.1"
                            value={startTotal}
                            onChange={(e) =>
                              setStartTotal(parseFloat(e.target.value))
                            }
                            required
                          ></input>
                        </div>
                        <div className="col-6">
                          <label>
                            {couponTypeId === 1 ? "End Total" : ""}{" "}
                            {couponTypeId === 2 ? "End Price" : ""}{" "}
                          </label>
                          <input
                            type="number"
                            id="EndPrice"
                            className="form-control"
                            placeholder="Price"
                            min="0"
                            step="0.1"
                            value={endTotal}
                            onChange={(e) =>
                              setEndTotal(parseFloat(e.target.value))
                            }
                            required
                          ></input>
                        </div>
                      </div>
                    ) : null}

                    {couponTypeId == 1 ? (
                      <>
                        <div className="row mt-4">
                          <div className="form-group col-12">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="Action"
                              id="None"
                              value={0}
                              checked={action == 0}
                              onChange={(e) => handleAction(e.target.value)}
                            />
                            &nbsp;
                            <label className="form-check-label" htmlFor="None">
                              None
                            </label>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <input
                              className="form-check-input"
                              type="radio"
                              name="Action"
                              id="Amount"
                              value={1}
                              checked={action == 1}
                              onChange={(e) => handleAction(e.target.value)}
                            />
                            &nbsp;
                            <label className="form-check-label" htmlFor="Amount">
                              Amount <span className="required">*</span>
                            </label>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <input
                              className="form-check-input"
                              type="radio"
                              name="Action"
                              id="Percentage"
                              value={2}
                              onChange={(e) => handleAction(e.target.value)}
                              checked={action == 2}
                            />
                            &nbsp;
                            <label
                              className="form-check-label"
                              htmlFor="Percentage"
                            >
                              Percentage <span className="required">*</span>
                            </label>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <div className="row">
                              {action == 0 ? <div className="col-6"></div> : null}
                              {action == 1 ? (
                                <div className="col-12">
                                  <div className="input-group">
                                    <input
                                      type="number"
                                      id="Action"
                                      className="form-control"
                                      placeholder="Amount"
                                      value={amount}
                                      min="1"
                                      step="0.1"
                                      onChange={(e) => handleAmount(e)}
                                      required
                                    ></input>
                                    <span className="input-group-text">$</span>
                                  </div>
                                </div>
                              ) : null}
                              {action == 2 ? (
                                <div className="col-12">
                                  <div className="input-group">
                                    <input
                                      type="number"
                                      id="Action"
                                      className="form-control"
                                      placeholder="Percentage"
                                      value={percentage}
                                      onChange={(e) =>
                                        setPercentage(parseFloat(e.target.value))
                                      }
                                      min="1"
                                      max="100"
                                      step="1"
                                      required
                                    ></input>
                                    <span className="input-group-text">%</span>
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="form-group col-3 " style={{ margin: "auto 0" }}>
                            <div className="m-zAuto">
                              <div className="form-check pl-38">
                                <label
                                  className="form-check-label"
                                  htmlFor="IsCoupon"
                                >
                                  Coupon
                                </label>
                                <input
                                  type="checkbox"
                                  id="IsCoupon"
                                  className="form-check-input"
                                  value={isCoupon}
                                  checked={isCoupon}
                                  onChange={(e) => handleIsCoupon(e)}
                                />
                              </div>
                            </div>
                          </div>

                          {isCoupon ? (
                            <div className="col-3">
                              <label>
                                Coupon Code <span className="required">*</span>{" "}
                              </label>
                              <input
                                type="text"
                                id="CouponCode"
                                className="form-control"
                                placeholder="Code"
                                value={couponCode}
                                onChange={(e) => setCouponCode(e.target.value)}
                                required
                              ></input>
                            </div>
                          ) : null}

                          {isCoupon ? (
                            <div className="col-3">
                              <label>
                                Limit <span className="required">*</span>
                              </label>
                              <div className="input-group">
                                <input
                                  type="number"
                                  id="UserLimit"
                                  className="form-control"
                                  placeholder="Limit"
                                  min="0"
                                  value={limit}
                                  onChange={(e) => handleLimit(e)}
                                  required
                                ></input>
                                <span className="input-group-text">/ coupon</span>
                              </div>
                            </div>
                          ) : null}

                          {isCoupon ? (
                            <div className="col-3">
                              <label>
                                Usage <span className="required">*</span>{" "}
                              </label>
                              <div className="input-group">
                                <input
                                  type="number"
                                  id="UsageTries"
                                  className="form-control"
                                  placeholder="Usage"
                                  min="0"
                                  value={usage}
                                  onChange={(e) =>
                                    setUsage(parseFloat(e.target.value))
                                  }
                                  required
                                ></input>
                                <span className="input-group-text">
                                  / customer
                                </span>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </>
                    ) : null}

                    {couponTypeId == 2 ? (
                      <div className="form-group">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="Action"
                          id="None"
                          value={0}
                          onChange={(e) => handleAction(e.target.value)}
                          checked={action == 0}
                        />
                        &nbsp;
                        <label className="form-check-label" htmlFor="None">
                          None
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <input
                          className="form-check-input"
                          type="radio"
                          name="Action"
                          id="Amount"
                          value={1}
                          onChange={(e) => handleAction(e.target.value)}
                          checked={action == 1}
                        />
                        &nbsp;
                        <label className="form-check-label" htmlFor="Amount">
                          Amount <span className="required">*</span>
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <input
                          className="form-check-input"
                          type="radio"
                          name="Action"
                          id="Percentage"
                          value={2}
                          checked={action == 2}
                          onChange={(e) => handleAction(e.target.value)}
                        />
                        &nbsp; &nbsp;
                        <label
                          className="form-check-label"
                          htmlFor="Percentage"
                        >
                          Percentage <span className="required">*</span>
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                        <div className="row">
                          {action == 0 ? <div className="col-6"></div> : null}
                          {action == 1 ? (
                            <div className="col-12">
                              <div className="input-group">
                                <input
                                  type="number"
                                  id="Action"
                                  className="form-control"
                                  placeholder="Amount"
                                  value={amount}
                                  onChange={(e) => setAmount(e.target.value)}
                                  min="1"
                                  step="0.1"
                                  required
                                ></input>
                                <span className="input-group-text">$</span>
                              </div>
                            </div>
                          ) : null}
                          {action == 2 ? (
                            <div className="col-12">
                              <div className="input-group">
                                <input
                                  type="number"
                                  id="Action"
                                  className="form-control"
                                  placeholder="Percentage"
                                  value={percentage}
                                  min="1"
                                  max="100"
                                  step="1"
                                  onChange={(e) =>
                                    setPercentage(parseFloat(e.target.value))
                                  }
                                  required
                                ></input>
                                <span className="input-group-text">%</span>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                    {CouponID != 0 ? (
                      <div className="form-group row mt-4">
                        <div className="row">
                          <label>Applied To : </label>
                        </div>
                        <div className="row mt-3">
                          <div className="form-check col-2 pl-38 ">
                            <label
                              className="form-check-label"
                              htmlFor="IsAppliedToCountries"
                            >
                              Country
                            </label>
                            <input
                              type="checkbox"
                              id="IsAppliedToCountries"
                              className="form-check-input"
                              value={isAppliedToCountries}
                              checked={isAppliedToCountries}
                              onChange={(e) =>
                                setIsAppliedToCountries(e.target.checked)
                              }
                            />
                          </div>
                          <div className="form-check col-2 pl-38">
                            <label
                              className="form-check-label"
                              htmlFor="IsAppliedToGroups"
                            >
                              Group
                            </label>
                            <input
                              type="checkbox"
                              id="IsAppliedToGroups"
                              className="form-check-input"
                              value={isAppliedToGroups}
                              checked={isAppliedToGroups}
                              onChange={(e) =>
                                setIsAppliedToGroups(e.target.checked)
                              }
                            />
                          </div>

                          <div className="form-check col-2 pl-38">
                            <label
                              className="form-check-label"
                              htmlFor="IsAppliedToCategories"
                            >
                              Category
                            </label>
                            <input
                              type="checkbox"
                              id="IsAppliedToCategories"
                              className="form-check-input"
                              defaultValue={isAppliedToCategories}
                              checked={isAppliedToCategories}
                              onChange={(e) => handleIsAppliedToCategories(e)}
                            />
                          </div>

                          <div className="form-check col-2 pl-38">
                            <label
                              className="form-check-label"
                              htmlFor="IsAppliedToAttributes"
                            >
                              Attribute Value
                            </label>
                            <input
                              type="checkbox"
                              id="IsAppliedToAttributes"
                              className="form-check-input"
                              defaultValue={isAppliedToAttributes}
                              checked={isAppliedToAttributes}
                              onChange={(e) => handleAppliedToAttributes(e)}
                            />
                          </div>

                          <div className="form-check col-2 pl-38">
                            <label
                              className="form-check-label"
                              htmlFor="IsAppliedToProducts"
                            >
                              Product
                            </label>
                            <input
                              type="checkbox"
                              id="IsAppliedToProducts"
                              className="form-check-input"
                              defaultValue={isAppliedToProducts}
                              checked={isAppliedToProducts}
                              onChange={(e) => handleIsAppliedToProducts(e)}
                            />
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            {isAppliedToCountries ? (
              <div className="card mb-5">
                <div className="card-header">
                  <div className="row">
                    <div className="col-6">
                      <h5 className="card-title">Assigned Countries</h5>
                    </div>
                    <div className="col-6 text-right">
                      <button
                        className="btn btn-primary"
                        onClick={() => setIsOpenUnassignedCountries(true)}
                      >
                        Assign Country
                      </button>
                      <Modal
                        show={isOpenUnassignedCountries}
                        onHide={() => setIsOpenUnassignedCountries(false)}
                        fullscreen={false}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Assign Request</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="container">
                            <div className="col-12">
                              <div className="row">
                                <div className="col-12">
                                  <div className="row mb-3">
                                    <div className="col-8"></div>
                                    <div className="col-4 text-end tblSearchBar position-relative">
                                      <span>
                                        <MdManageSearch />
                                      </span>
                                      <input
                                        type="text"
                                        placeholder="Search any field in table"
                                        className="form-control form-control-sm"
                                        onChange={(e) => handleSearchUnAssignedCountries(e)}
                                      ></input>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-12">
                                  <div className="portalTable">
                                    <DataTable
                                      columns={unassignedCountriesColumns}
                                      data={filteredUnAssignedCountries}
                                      pagination
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <div className="container">
                            <div className="row">
                              <div className="col-12 text-right">
                                <Button
                                  variant="secondary"
                                  onClick={() =>
                                    setIsOpenUnassignedCountries(0)
                                  }
                                >
                                  Close
                                </Button>
                                <Button
                                  variant="primary"
                                  className="ml-20"
                                  onClick={AssignAllCountries}
                                >
                                  Assign All
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-8"></div>
                    <div className="col-4 text-end tblSearchBar position-relative">
                      <span>
                        <MdManageSearch />
                      </span>
                      <input
                        type="text"
                        placeholder="Search any field in table"
                        className="form-control form-control-sm"
                        onChange={(e) => handleSearchAssignedCountries(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="portalTable">
                    <DataTable
                      columns={assignedCountriesColumns}
                      data={filteredAssignedCountries}
                      pagination
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {/* Assigned Groups */}
            {isAppliedToGroups ? (
              <div className="card mb-5">
                <div className="card-header">
                  <div className="row">
                    <div className="col-6">
                      <h5 className="card-title">Assigned Groups</h5>
                    </div>
                    <div className="col-6 text-right">
                      <button
                        className="btn btn-primary"
                        onClick={() => setIsOpenUnassignedGroups(true)}
                      >
                        Assign Groups
                      </button>
                      <Modal
                        show={isOpenUnassignedGroups}
                        onHide={() => setIsOpenUnassignedGroups(false)}
                        fullscreen={false}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Assign Request</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="container">
                            <div className="row">
                              <div className="col-12">
                                <div className="row mb-3">
                                  <div className="col-8"></div>
                                  <div className="col-4 text-end tblSearchBar position-relative">
                                    <span>
                                      <MdManageSearch />
                                    </span>
                                    <input
                                      type="text"
                                      placeholder="Search any field in table"
                                      className="form-control form-control-sm"
                                      onChange={(e) => handleSearchUnAssignedGroups(e)}
                                    ></input>
                                  </div>
                                </div>
                                <div className="portalTable">
                                  <DataTable
                                    columns={unassignedGroupsColumns}
                                    data={filteredUnAssignedGroups}
                                    pagination
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <div className="container">
                            <div className="row">
                              <div className="col-12 text-right">
                                <Button
                                  variant="secondary"
                                  onClick={() =>
                                    setIsOpenUnassignedGroups(false)
                                  }
                                >
                                  Close
                                </Button>
                                <Button
                                  variant="primary"
                                  className="ml-20"
                                  onClick={AssignAllGroups}
                                >
                                  Assign All
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-8"></div>
                    <div className="col-4 text-end tblSearchBar position-relative">
                      <span>
                        <MdManageSearch />
                      </span>
                      <input
                        type="text"
                        placeholder="Search any field in table"
                        className="form-control form-control-sm"
                        onChange={(e) => handleSearchAssignedGroups(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="portalTable">
                    <DataTable
                      columns={assignedGroupsColumns}
                      data={filteredAssignedGroups}
                      pagination
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {/* Assigned Categories */}
            {isAppliedToCategories ? (
              <div className="card mb-5">
                <div className="card-header">
                  <div className="row">
                    <div className="col-6">
                      <h5 className="card-title">Assigned Categories</h5>
                    </div>
                    <div className="col-6 text-right">
                      <button
                        className="btn btn-primary"
                        onClick={() => setIsOpenUnAssignedCategories(true)}
                      >
                        Assign Categories
                      </button>
                      <Modal
                        show={isOpenUnAssignedCategories}
                        onHide={() => setIsOpenUnAssignedCategories(false)}
                        fullscreen={false}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Assign Request</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="container">
                            <div className="row">
                              <div className="col-12">
                                <div className="row mb-3">
                                  <div className="col-8"></div>
                                  <div className="col-4 text-end tblSearchBar position-relative">
                                    <span>
                                      <MdManageSearch />
                                    </span>
                                    <input
                                      type="text"
                                      placeholder="Search any field in table"
                                      className="form-control form-control-sm"
                                      onChange={(e) => handleSearchUnAssignedCategories(e)}
                                    ></input>
                                  </div>
                                </div>
                                <div className="portalTable">
                                  <DataTable
                                    columns={unassignedCategoriesColumns}
                                    data={filteredUnAssignedCategories}
                                    pagination
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <div className="container">
                            <div className="row">
                              <div className="col-12 text-right">
                                <Button
                                  variant="secondary"
                                  onClick={() =>
                                    setIsOpenUnAssignedCategories(false)
                                  }
                                >
                                  Close
                                </Button>
                                <Button
                                  variant="primary"
                                  className="ml-20"
                                  onClick={AssignAllCategories}
                                >
                                  Assign All
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-8"></div>
                    <div className="col-4 text-end tblSearchBar position-relative">
                      <span>
                        <MdManageSearch />
                      </span>
                      <input
                        type="text"
                        placeholder="Search any field in table"
                        className="form-control form-control-sm"
                        onChange={(e) => handleSearchAssignedCategories(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="portalTable">
                    <DataTable
                      columns={assignedCategoriesColumns}
                      data={filteredAssignedCategories}
                      pagination
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {isAppliedToAttributes ? (
              <div className="card mb-5">
                <div className="card-header">
                  <div className="row">
                    <div className="col-6">
                      <h5 className="card-title">Assigned Attribute Values</h5>
                    </div>
                    <div className="col-6 text-right">
                      <button
                        className="btn btn-primary"
                        onClick={() => setisOpenUnAssignedAttributeValues(true)}
                      >
                        Assign Attribute Value
                      </button>
                      <Modal
                        show={isOpenUnAssignedAttributeValues}
                        onHide={() => setisOpenUnAssignedAttributeValues(false)}
                        fullscreen={false}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Assign Request</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="container">
                            <div className="row">
                              <div className="col-12">
                                <div className="row mb-3">
                                  <div className="col-8"></div>
                                  <div className="col-4 text-end tblSearchBar position-relative">
                                    <span>
                                      <MdManageSearch />
                                    </span>
                                    <input
                                      type="text"
                                      placeholder="Search any field in table"
                                      className="form-control form-control-sm"
                                      onChange={(e) => handleSearchUnAssignedAttributeValues(e)}
                                    ></input>
                                  </div>
                                </div>
                                <div className="portalTable">
                                  <DataTable
                                    columns={unassignedAttributeValuesColumns}
                                    data={filteredUnAssignedAttributeValues}
                                    pagination
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <div className="container">
                            <div className="row">
                              <div className="col-12 text-right">
                                <Button
                                  variant="secondary"
                                  onClick={() =>
                                    setisOpenUnAssignedAttributeValues(false)
                                  }
                                >
                                  Close
                                </Button>
                                <Button
                                  variant="primary"
                                  className="ml-20"
                                  onClick={AssignAllAttributeValues}
                                >
                                  Assign All
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-8"></div>
                    <div className="col-4 text-end tblSearchBar position-relative">
                      <span>
                        <MdManageSearch />
                      </span>
                      <input
                        type="text"
                        placeholder="Search any field in table"
                        className="form-control form-control-sm"
                        onChange={(e) => handleSearchAssignedAttributeValues(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="portalTable">
                    <DataTable
                      columns={assignedAttributeValuesColumns}
                      data={filteredAssignedAttributeValues}
                      pagination
                    />
                  </div>
                </div>
              </div>
            ) : null}
            {isAppliedToProducts === true ? (
              <div className="card mb-5">
                <div className="card-header">
                  <div className="row">
                    <div className="col-6">
                      <h5 className="card-title">Assigned Products</h5>
                    </div>
                    <div className="col-6 text-right">
                      <button
                        className="btn btn-primary"
                        onClick={() => setisOpenUnAssignedProducts(true)}
                      >
                        Assign Product
                      </button>
                      <Modal
                        show={isOpenUnAssignedProducts}
                        onHide={() => setisOpenUnAssignedProducts(false)}
                        fullscreen={false}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Assign Request</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="container">
                            <div className="row">
                              <div className="col-12">
                                <div className="row mb-3">
                                  <div className="col-8"></div>
                                  <div className="col-4 text-end tblSearchBar position-relative">
                                    <span>
                                      <MdManageSearch />
                                    </span>
                                    <input
                                      type="text"
                                      placeholder="Search any field in table"
                                      className="form-control form-control-sm"
                                      onChange={(e) => handleSearchUnAssignedProducts(e)}
                                    ></input>
                                  </div>
                                </div>
                                <div className="portalTable">
                                  {/* <DataTable
                          columns={unassignedProductsColumns}
                          data={filteredUnAssignedProducts}
                          pagination
                        /> */}

                                  <DataTable
                                    columns={unassignedProductsColumns}
                                    data={filteredUnAssignedProducts}
                                    pagination
                                    expandableRows
                                    expandableRowsComponent={
                                      unassignedExpandableRows
                                    }
                                    expandableRowDisabled={(row) => row.disabled}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <div className="container">
                            <div className="row">
                              <div className="col-12 text-right">
                                <Button
                                  variant="secondary"
                                  onClick={() =>
                                    setisOpenUnAssignedProducts(false)
                                  }
                                >
                                  Close
                                </Button>
                                <Button
                                  variant="primary"
                                  className="ml-20"
                                  onClick={AssignAllProducts}
                                >
                                  Assign All
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-8"></div>
                    <div className="col-4 text-end tblSearchBar position-relative">
                      <span>
                        <MdManageSearch />
                      </span>
                      <input
                        type="text"
                        placeholder="Search any field in table"
                        className="form-control form-control-sm"
                        onChange={(e) => handleSearchAssignedProducts(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="portalTable">
                    <DataTable
                      columns={assignedProductsColumns}
                      data={filteredAssignedProducts}
                      pagination
                      expandableRows
                      expandableRowsComponent={assignedExpandableRows}
                      expandableRowDisabled={(row) => row.disabled}
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default ManageCoupons;
